export default "__VITE_ASSET__DQv34YYI__"